import React, { useEffect, useState } from 'react';
import LinedTitle from '../../LinedTitle/LinedTitle';
import DynaSelectBox from '../../../A13/DynaView/DynaSelectBox';
import DynaInput from '../../../A13/DynaView/DynaInput';
import { TrashSVG } from '../../ChikaExportSvg/ChikaExportSvg';
import _axios from '../../../../httpService';
import { prefixUrl } from '../../../../utils/utilsData';
import { useNavigate, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import Loader from '../../../Loader';
import UtilsFunctions from '../../../../utils/UtilsFunctions';
import './ProductFormula.scss';

const ProductFormula = () => {
  const navigateTo = useNavigate();
  const myLocation = useLocation();
  const [selectData, setSelectData] = useState({
    mahsols: [],
    products: [],
    mahsolMiyani: [],
  });
  const [newKala, setNewKala] = useState({
    id_kala: "",
    te: "",
  });
  const [newMiyani, setNewMiyani] = useState({
    id_miyani: "",
    te: "",
  });
  const [sendData, setSendData] = useState({
    id_mahsoul: "",
    formulas: [],
    miyani: []
  });
  const [isInitialDataLoaded, setIsInitialDataLoaded] = useState(false);
  const [isLoad, setIsLoad] = useState(false);

  const fetchInitialData = async () => {
    const response = await _axios.get(prefixUrl() + "/cheeka/?request=productFormulaInitialData")
    if (response?.data?.status) {
      let data = response?.data?.data;
      setSelectData({
        mahsols: data.mahsolsList,
        products: data.productsList,
        mahsolMiyani: data.mahsol_miyani,
      });
      setIsInitialDataLoaded(true);
      if (myLocation?.state?.mode !== "edit") setIsLoad(true);
    } else {
      toast.error(response?.data?.message);
    }
  };

  const getEditModeData = async () => {
    const response = await _axios.get(prefixUrl() + "/cheeka/?request=getSubmittedFormula&id_mahsoul=" + myLocation?.state?.id);
    if (response?.data?.status) {
      const data = response?.data?.data;
      setSendData({
        id_mahsoul: data?.id_mahsoul,
        formulas: data?.formulas || [],
        miyani: data?.miyani || []
      });
      setIsLoad(true);
    } else {
      toast.error(response.data.message);
    }
  };

  useEffect(() => {
    void fetchInitialData();
  }, []);

  useEffect(() => {
    if (myLocation?.state?.mode === "edit" && isInitialDataLoaded) {
      void getEditModeData();
    }
  }, [isInitialDataLoaded]);

  const AddNewMiyani = () => {
    const validations = {
      'لطفاً یک محصول میانی انتخاب کنید.': !newMiyani?.id_miyani,
      'این محصول میانی قبلاً اضافه شده است.': sendData.miyani.some((m) => m.id_miyani === newMiyani?.id_miyani),
      'لطفا تعداد محصول میانی را مشخص کنید': !newMiyani?.te || Number(newMiyani?.te) === 0,
    };

    for (const [message, condition] of Object.entries(validations)) {
      if (condition) return toast.error(message);
    }

    const selectedMiyaniObj = selectData?.mahsolMiyani.find(m => m.value === newMiyani?.id_miyani);

    if (selectedMiyaniObj) {
      const newItem = {
        id_miyani: newMiyani.id_miyani,
        te: newMiyani.te,
        name_miyani: selectedMiyaniObj.label,
        type: "محصول میانی"
      };

      setSendData((prev) => ({
        ...prev,
        miyani: [...prev.miyani, newItem]
      }));

      setNewMiyani({
        id_miyani: "",
        te: ""
      });
    }
  };

  const AddNewKala = () => {
    const validations = {
      'لطفاً یک کالا انتخاب کنید.': !newKala?.id_kala,
      'این کالا قبلاً اضافه شده است.': sendData?.formulas.some((k) => k.id_kala === newKala?.id_kala),
      'لطفا تعداد کالا را مشخص کنید': !newKala?.te || Number(newKala?.te) === 0,
    };

    for (const [message, condition] of Object.entries(validations)) {
      if (condition) return toast.error(message);
    }

    const selectedKalaObj = selectData?.products.find(k => k.value === newKala?.id_kala);

    if (selectedKalaObj) {
      const newItem = {
        id_kala: newKala.id_kala,
        te: newKala.te,
        title_kala: selectedKalaObj.label,
        type: "کالا"
      };

      setSendData((prev) => ({
        ...prev,
        formulas: [...prev.formulas, newItem]
      }));

      setNewKala({
        id_kala: "",
        te: ""
      });
    }
  };

  const handleDeleteKala = (index) => {
    setSendData((prev) => ({
      ...prev,
      formulas: prev.formulas.filter((_, i) => i !== index)
    }));
  };

  const handleDeleteMiyani = (index) => {
    setSendData((prev) => ({
      ...prev,
      miyani: prev.miyani.filter((_, i) => i !== index)
    }));
  };

  const handleTableChange = (index, field, value, type) => {
    const numericValue = UtilsFunctions.removeCommas(value).replace(/\D/g, "");

    if (type === "miyani") {
      setSendData((prev) => ({
        ...prev,
        miyani: prev.miyani.map((item, i) =>
          i === index ? { ...item, [field]: numericValue } : item
        ),
      }));
    } else if (type === "formulas") {
      setSendData((prev) => ({
        ...prev,
        formulas: prev.formulas.map((item, i) =>
          i === index ? { ...item, [field]: numericValue } : item
        ),
      }));
    }
  };

  const validation = () => {
    if (!sendData?.id_mahsoul) {
      toast.error("لطفاً محصول را انتخاب کنید.");
      return false;
    }
    if (sendData?.miyani?.length === 0 && sendData?.formulas?.length === 0) {
      toast.error("لطفاً حداقل یک داده به جدول اضافه کنید.");
      return false;
    }
    for (const [index, item] of sendData?.miyani?.entries()) {
      if (!item.te || Number(item.te) === 0) {
        toast.error(`تعداد محصول میانی "${item.name_miyani}" نمی‌تواند صفر باشد.`);
        return false;
      }
    }
    for (const [index, item] of sendData?.formulas?.entries()) {
      if (!item.te || Number(item.te) === 0) {
        toast.error(`تعداد کالا "${item.title_kala}" نمی‌تواند صفر باشد.`);
        return false;
      }
    }
    return true;
  };

  const handleSubmit = () => {
    const dataToSend = {
      id_mahsoul: sendData?.id_mahsoul,
      formulas: sendData?.formulas.map(v => ({
        id_kala: v.id_kala,
        te: v.te
      })),
      miyani: sendData?.miyani.map(v => ({
        id_miyani: v.id_miyani,
        te: v.te
      })),
    };

    const submitFormulaRequest = _axios.post(
      prefixUrl() + "/cheeka/?request=submitProductFormula",
      dataToSend
    ).then((res) => {
      if (res.data.status) {
        toast.success(res.data.message);
        navigateTo(-1);
      }
    }).catch((error) => console.log(error));

    toast.promise(submitFormulaRequest, {
      pending: "در حال ارسال اطلاعات...",
    });
  }

  try {
    return !isLoad ? (
      <Loader />
    ) : (
      <section className='product__formula'>
        <div className='content__section'>
          <LinedTitle title={"مشخصات محصول"} />
          <div className='input__container'>
            <DynaSelectBox
              options={selectData?.mahsols}
              hasFilter={false}
              label={"انتخاب محصول"}
              className={"solid-dyna-input"}
              value={sendData?.id_mahsoul}
              onChange={(data) => setSendData({
                ...sendData,
                id_mahsoul: data?.value
              })}
            />
          </div>

          <LinedTitle title={"مشخصات محصول میانی"} />
          <div className='input__container'>
            <DynaSelectBox
              options={selectData?.mahsolMiyani}
              hasFilter={false}
              label={"انتخاب محصول میانی"}
              className={"solid-dyna-input"}
              value={newMiyani?.id_miyani}
              onChange={(data) => setNewMiyani({
                ...newMiyani,
                id_miyani: data?.value
              })}
            />
            <DynaInput
              label={"تعداد"}
              name={"te"}
              className={"solid-dyna-input"}
              placeholder={"تعداد را وارد کنید"}
              value={UtilsFunctions.addCommas(newMiyani?.te)}
              type={"text"}
              hasComma={true}
              setDataFromComponent={(data) => setNewMiyani({
                ...newMiyani,
                te: data?.te
              })}
            />
            <button className='add__button' onClick={AddNewMiyani}>
              افزودن
            </button>
          </div>

          <LinedTitle title={"مشخصات کالا"} />
          <div className='input__container'>
            <DynaSelectBox
              options={selectData?.products}
              hasFilter={false}
              label={"انتخاب کالا"}
              className={"solid-dyna-input"}
              value={newKala?.id_kala}
              onChange={(data) => setNewKala({
                ...newKala,
                id_kala: data?.value
              })}
            />
            <DynaInput
              label={"تعداد"}
              name={"te"}
              className={"solid-dyna-input"}
              placeholder={"تعداد را وارد کنید"}
              value={UtilsFunctions.addCommas(newKala?.te)}
              type={"text"}
              hasComma={true}
              setDataFromComponent={(data) => setNewKala({
                ...newKala,
                te: data?.te
              })}
            />
            <button className='add__button' onClick={AddNewKala}>
              افزودن
            </button>
          </div>

          <div className='table__section'>
            <div className="table__box">
              <ul className="table__header">
                <li className="table__row">
                  <div style={{ width: "15%" }} className="table__cell">کد محصول میانی/کالا</div>
                  <div style={{ width: "55%" }} className="table__cell">نام محصول میانی/کالا</div>
                  <div style={{ width: "10%" }} className="table__cell">نوع</div>
                  <div style={{ width: "10%" }} className="table__cell">تعداد</div>
                  <div style={{ width: "10%" }} className="table__cell">عملیات</div>
                </li>
              </ul>
              <ul className='table__body'>
                {sendData?.miyani.map((v, index) => (
                  <li key={index} className="table__row">
                    <div style={{ width: "15%" }} className="table__cell">{v?.id_miyani}</div>
                    <div style={{ width: "55%" }} className="table__cell">{v?.name_miyani}</div>
                    <div style={{ width: "10%" }} className="table__cell">{v?.type}</div>
                    <div style={{ width: "10%" }} className="table__cell">
                      <input
                        type="text"
                        value={UtilsFunctions.addCommas(v?.te)}
                        onChange={(e) => handleTableChange(index, 'te', e.target.value, 'miyani')}
                        onFocus={() => v.te == 0 && handleTableChange(index, 'te', '', 'miyani')}
                        onBlur={() => v.te == '' && handleTableChange(index, 'te', '0', 'miyani')}
                      />
                    </div>
                    <div style={{ width: "10%" }} className="table__cell operation">
                      <button className='trash__button' onClick={() => handleDeleteMiyani(index)}>
                        <TrashSVG />
                      </button>
                    </div>
                  </li>
                ))}
                {sendData?.formulas.map((v, index) => (
                  <li key={index} className="table__row">
                    <div style={{ width: "15%" }} className="table__cell">{v?.id_kala}</div>
                    <div style={{ width: "55%" }} className="table__cell">{v?.title_kala}</div>
                    <div style={{ width: "10%" }} className="table__cell">{v?.type}</div>
                    <div style={{ width: "10%" }} className="table__cell">
                      <input
                        type="text"
                        value={UtilsFunctions.addCommas(v?.te)}
                        onChange={(e) => handleTableChange(index, 'te', e.target.value, 'formulas')}
                        onFocus={() => v.te == 0 && handleTableChange(index, 'te', '', 'formulas')}
                        onBlur={() => v.te == '' && handleTableChange(index, 'te', '0', 'formulas')}
                      />
                    </div>
                    <div style={{ width: "10%" }} className="table__cell operation">
                      <button className='trash__button' onClick={() => handleDeleteKala(index)}>
                        <TrashSVG />
                      </button>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>

        <div className="bottom__section">
          <div className="action__buttons">
            <button onClick={() => navigateTo(-1)} className="cancel__button">انصراف</button>
            <button
              onClick={() => {
                if (validation()) {
                  handleSubmit();
                }
              }}
              className="submit__button">ثبت</button>
          </div>
        </div>
      </section>
    );
  } catch (e) {
    return <>{e.toString()}</>
  }
};

export default ProductFormula;